/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { BackupStatus } from '../models/BackupStatus';

export class BackupStatusFilters {
  /**
  * Matches if any value in this list equals `backupStatus`.
  */
  '_in'?: Array<BackupStatus>;
  /**
  * Matches if no value in this list equals `backupStatus`.
  */
  'notIn'?: Array<BackupStatus>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "_in",
      "baseName": "in",
      "type": "Array<BackupStatus>",
      "format": ""
    },
    {
      "name": "notIn",
      "baseName": "notIn",
      "type": "Array<BackupStatus>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return BackupStatusFilters.attributeTypeMap;
  }

  public constructor() {
  }
}

